import DemoShell from "../components/layout/demo-shell";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { refreshToken, tokenExpiry, isTokenExpired, getTokenExpiry } from '../lib/auth'
import Loading from '../components/ui/loading'
import LandingHero from "../components/layout/landing-hero";
import LandingFeatures from "../components/layout/landing-features";
import LandingWorkpegEmail from "../components/layout/landing-workpeg-email";
import LandingPreFooter from "../components/layout/landing-pre-footer";
import LandingFooter from "../components/ui/landing-footer";
import { getCachedBusiness } from "../lib/utils";

const Home = () => {
    const router = useRouter()
    const [tokenExpiryDate, setTokenExpiryDate] = useState(null);

    useEffect(() => {
        const handleAuth = async () => {
            try {
                await refreshToken();
                setTokenExpiryDate(getTokenExpiry());

                if (!isTokenExpired(getTokenExpiry())) {
                    router.push(`/${getCachedBusiness()}/inbox`);
                }
            } catch (error) {
                setTokenExpiryDate(new Date(Date.now() - 60000));
            }
        };

        handleAuth();
    }, [router]);


    if (tokenExpiryDate === null) return <Loading />
    if (isTokenExpired(tokenExpiryDate)) {
        return (
            <DemoShell>
                <LandingHero />
                <LandingFeatures/>
                <LandingWorkpegEmail/>
                <LandingPreFooter/>
                <LandingFooter/>
            </DemoShell>
        );
    }
};

Home.isUnprotected = true;
export default Home;